import React from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {paginaDelMenu, spazioVip} from '../../moduli/leggi';
import {useSkin} from '../../moduli/useSkin';
import Nota from '../Vetrina/Nota';
import {TestoImpaginato} from '../Vetrina/PaginaTesto';
import './Pagine.css';

/** Le intestazioni delle colonne dei livelli, scritte come t('…') cosi' la raccolta delle parole le vede. */
function intestazione(k, t) {
  if (k === 'punti') return t('Punti');
  if (k === 'bonus') return t('Bonus settimanale');
  if (k === 'compleanno') return t('Compleanno');
  if (k === 'cambio') return t('Cambio punti');
  return t('Cashback');
}

/**
 * LA PAGINA SPAZIO VIP (modulo Pagine › Spazio VIP, /vip): il titolo grande
 * con la prima parola in oro, una frase e un testo, i vantaggi in riquadri
 * (due per riga dal computer), la tabella dei livelli con solo le colonne
 * che almeno un livello riempie, e il pulsante in fondo.
 *
 * I PUNTI E IL LIVELLO DEL GIOCATORE NON CI SONO: li dara' il backend
 * (profilo di gioco) e allora qui comparira' la barra «Challenger, 2.340
 * punti: Competitor a 5.000». Finche' non c'e', la pagina non inventa
 * niente: e' scritto nel documento dell'API per il backend.
 */
export default function SpazioVip() {
  useSkin();
  const {t} = useTranslation();
  const navigate = useNavigate();
  const pagina = paginaDelMenu('vip');
  const p = spazioVip();
  if (!pagina || !pagina.acceso) return <Navigate to={'/'} replace/>;
  const titolo = pagina.titolo === pagina.titoloDiSerie ? t('Spazio VIP') : pagina.titolo;
  const [prima, ...resto] = (p.aperturaTitolo || titolo).split(' ');
  const vai = (dove) => {
    if (!dove) return;
    if (/^https?:\/\//i.test(dove)) window.open(dove, '_blank', 'noopener');
    else navigate(dove);
  };
  const vuota = !p.vantaggi.length && !p.livelli.length;
  return (
    <div className={'vetrina pg-vip'}>
      <section className={'pg-vip-apertura'} aria-label={titolo}>
        <h1><span className={'pg-vip-oro'}>{prima}</span>{resto.length > 0 && ' ' + resto.join(' ')}</h1>
        {p.aperturaRiga && <p className={'pg-vip-riga'}>{p.aperturaRiga}</p>}
        {p.aperturaTesto && <div className={'pg-vip-testo'}><TestoImpaginato testo={p.aperturaTesto}/></div>}
        {p.vantaggi.length > 0 && (
          <ul className={'pg-vantaggi'} aria-label={t('I vantaggi')}>
            {p.vantaggi.map((v, i) => (
              <li key={i} className={'pg-vantaggio'}>
                <span className={'pg-vantaggio-icona'} aria-hidden={'true'}>{v.icona || '✨'}</span>
                <span className={'pg-vantaggio-testi'}><strong>{v.titolo}</strong>{v.testo && <span>{v.testo}</span>}</span>
              </li>
            ))}
          </ul>
        )}
      </section>
      {vuota && (
        <Nota tono={'spento'} giocatore={t('Lo spazio VIP sta arrivando.')}>
          {t('Vantaggi e livelli si scrivono dal backoffice (Moduli › Pagine › Spazio VIP). Oggi non sono ancora scritti.')}
        </Nota>
      )}
      {p.livelli.length > 0 && (
        <section className={'pg-corpo'} aria-label={p.livelliTitolo || t('I livelli')}>
          <h2 className={'pg-titolo'}>{p.livelliTitolo || t('I livelli')}</h2>
          <div className={'pg-tabella-scorri'}>
            <table className={'pg-livelli'}>
              <thead>
                <tr>
                  <th scope={'col'}>{t('Livello')}</th>
                  {p.colonne.map((k) => <th scope={'col'} key={k}>{intestazione(k, t)}</th>)}
                </tr>
              </thead>
              <tbody>
                {p.livelli.map((l, i) => (
                  <tr key={i}>
                    <th scope={'row'}><span className={'pg-livello-gemma'} aria-hidden={'true'} style={{'--i': i}}/>{l.nome}</th>
                    {p.colonne.map((k) => <td key={k} className={'pg-col-' + k}>{l[k] || '—'}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
      {p.pulsante && p.collegamento && (
        <div className={'pg-piede'}>
          <button type={'button'} className={'pg-oro'} onClick={() => vai(p.collegamento)}>{p.pulsante}</button>
        </div>
      )}
    </div>
  );
}
